module.exports = __webpack_public_path__ + "static/media/verify-email_mobile.a24ff2f3.png";